import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import { useParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import Spinner from "../../components/Reusable/Spinner";
import usePatchHook from "../../customHooks/usePatchHook";
const EditSubjectComponent = loadable(
  () => import("../../components/Subject/EditSubject")
);

const EditSubject = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetHook({
    queryKey: [`subject-${id}`],
    url: `${APIS.SUBJECT}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchloading } = usePatchHook({
    queryKey: [`subject-${id}`],
    navigateURL: "subject",
  });

  const handleEdit = async (value: any, setError: any) => {
    let formData = {
      ...value,
    };
    const url = `${APIS.SUBJECT}${id}/`;
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditSubjectComponent data={data} handleEdit={handleEdit} />
      )}
    </>
  );
};

export default EditSubject;
